import { render } from "./TeamAssignmentView.vue?vue&type=template&id=dcf05602&scoped=true"
import script from "./TeamAssignmentView.vue?vue&type=script&lang=js"
export * from "./TeamAssignmentView.vue?vue&type=script&lang=js"

import "./TeamAssignmentView.vue?vue&type=style&index=0&id=dcf05602&scoped=true&lang=css"

import exportComponent from "/Users/georgeconstantine/Documents/import/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcf05602"]])

export default __exports__